import React from "react";
import { useOutletContext } from "react-router-dom";
import useSEO from "@/hooks/useSEO";

const ABOUT_HERO_BG =
  "https://images.unsplash.com/photo-1500835556837-99ac94a94552?auto=format&fit=crop&w=2000&q=80";
const ABOUT_IMG =
  "https://images.unsplash.com/photo-1495395226200-8fbf6b720b8c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const About = () => {
  useSEO({
    title: "About",
    description: "Shaurya Travels is a Pune-based travel agency crafting handpicked journeys across India and beyond — backed by years of road-tested experience.",
    path: "/about",
  });
  const { settings } = useOutletContext();
  return (
    <div data-testid="about-page">
      <section className="relative h-[55vh] min-h-[380px] w-full overflow-hidden">
        <img src={ABOUT_HERO_BG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 h-full flex flex-col justify-end pb-14 text-white">
          <p className="text-xs uppercase tracking-[0.4em] opacity-80 mb-4 fade-up">— About</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-7xl leading-[1.0] fade-up-2">
            {settings?.about_title || "Our Story"}
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-12 mt-20 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 pb-8">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <img
            src={ABOUT_IMG}
            alt="About Shaurya Travels"
            className="w-full h-[60vh] lg:h-[80vh] object-cover"
          />
        </div>
        <div className="lg:col-span-7 order-1 lg:order-2 lg:pt-8">
          <div className="space-y-6 text-[var(--st-ink-2)] text-lg leading-relaxed max-w-2xl">
            {(settings?.about_text || "").split("\n").map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>

          <div className="grid grid-cols-3 gap-6 mt-16 max-w-xl">
            {[
              { k: "10+", v: "Years on the road" },
              { k: "120", v: "Destinations" },
              { k: "∞", v: "Stories captured" },
            ].map((s) => (
              <div key={s.v}>
                <div className="font-serif-display text-4xl text-[var(--st-accent)]">{s.k}</div>
                <div className="text-xs uppercase tracking-[0.2em] mt-2 text-[var(--st-ink-2)]">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
